<div class="doc-layout">
    <!-- Sidebar -->
    <aside class="doc-sidebar" [class.collapsed]="sidebarCollapsed">
        <div class="doc-sidebar-header">
            <div class="doc-logo-row">
                <img src="assets/winwin-horizontal.png" alt="logo" class="doc-logo">
                <span class="doc-label">Docs</span>
            </div>
            <button class="doc-collapse-btn" (click)="sidebarCollapsed = !sidebarCollapsed">
                <i class="fa" [class.fa-chevron-left]="!sidebarCollapsed" [class.fa-chevron-right]="sidebarCollapsed"></i>
            </button>
        </div>

        <div class="doc-sidebar-body" *ngIf="!sidebarCollapsed">
            <!-- Search -->
            <div class="doc-search-box">
                <i class="fa fa-search doc-search-icon"></i>
                <input type="text" class="doc-search-input" placeholder="Search docs..." [value]="search_query" (keyup)="search($event)">
            </div>

            <!-- Categories & Documents tree -->
            <nav class="doc-nav">
                <div class="doc-nav-group" *ngFor="let category of categories">
                    <button class="doc-nav-category" 
                            [class.active]="category_id == category.id"
                            (click)="selectCategory(category.id)">
                        <i class="fa fa-folder-o doc-nav-icon" [class.fa-folder-open-o]="category_id == category.id"></i>
                        <span class="doc-nav-category-title">{{category.title}}</span>
                        <i class="fa fa-chevron-down doc-nav-chevron" [class.open]="category_id == category.id"></i>
                    </button>
                    <div class="doc-nav-items" *ngIf="category_id == category.id">
                        <a class="doc-nav-item" 
                           *ngFor="let doc of temp_documents"
                           [class.active]="doc.uuid == document_uuid"
                           [routerLink]="['/document', doc.uuid]" 
                           [fragment]="category_id">
                            <i class="fa fa-file-text-o doc-nav-item-icon"></i>
                            <span>{{doc.title}}</span>
                        </a>
                        <div class="doc-nav-empty" *ngIf="temp_documents.length === 0">
                            No documents found
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </aside>

    <!-- Main Content -->
    <main class="doc-main">
        <!-- Top bar -->
        <div class="doc-topbar">
            <button class="doc-mobile-toggle" (click)="sidebarCollapsed = !sidebarCollapsed">
                <i class="fa fa-bars"></i>
            </button>
            <nav class="doc-breadcrumb" *ngIf="document?.title">
                <a [routerLink]="['/document']" class="doc-breadcrumb-link">Documentation</a>
                <i class="fa fa-chevron-right doc-breadcrumb-sep"></i>
                <span class="doc-breadcrumb-current">{{document.title}}</span>
            </nav>
            <nav class="doc-breadcrumb" *ngIf="!document?.title">
                <span class="doc-breadcrumb-current">Documentation</span>
            </nav>
            <div class="doc-topbar-spacer"></div>
            <button class="doc-download-btn" (click)="downloadPdf()" [disabled]="downloading">
                <i class="fa" [class.fa-file-pdf-o]="!downloading" [class.fa-spinner]="downloading" [class.fa-spin]="downloading"></i>
                <span>{{ downloading ? 'Generating...' : 'Download PDF' }}</span>
            </button>
        </div>

        <!-- Content area -->
        <div class="doc-content-wrapper">
            <!-- Welcome state when no document selected -->
            <div class="doc-welcome" *ngIf="!document?.title">
                <div class="doc-welcome-icon">
                    <i class="fa fa-book"></i>
                </div>
                <h2 class="doc-welcome-title">Documentation</h2>
                <p class="doc-welcome-desc">Select a category from the sidebar, then choose a document to get started.</p>
            </div>

            <!-- Document content -->
            <div class="doc-content" *ngIf="document?.title">
                <app-document [document]="document"></app-document>
            </div>
        </div>
    </main>
</div>